<ng-container *ngFor="let transferGroup of day.transfers || []">
  <div class="row" *ngFor="let transfer of transferGroup.optionals">
    <div class="col-12 pl-4 pt-2">
      <span class="overview-icons"> <app-service-icon [icon]="'taxi'" [customPath]="getServiceIconPath('taxi')"></app-service-icon> </span>
      <span class="text-capitalize">{{ transfer.type?.toLowerCase() }}</span>
    </div>
  </div>
</ng-container>
